export const updateRemainingTime = () => ({
    type: 'UPDATE_REMAINING_TIME'
});

export const resetRemainingTime = () => ({
    type: 'RESET_REMAINING_TIME'
});